






















import Vue from "vue";
import iwInputSelect from "../buildingBlocks/InputSelect.vue";
import {addDefaultValuesToStore, killNotRelevantCriteria, resetBasicInfo} from "@/shared/scripts/ValidateData";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "property.type",
            pathInStoreSubtype: "property.subtype"
        };
    },
    computed: {
        ...mapGetters({
            getValue: "FormModule/getValue",
            isReadonlyField: "FormModule/isReadonlyField",
            getFirstPublicationDate: "FormModule/getFirstPublicationDate"
        }),
        isEditionMode: function(): boolean {
            return this.$store.getters["FormModule/getIsEditionMode"];
        },
        propertyType: function(): string {
            return this.getValue(this.pathInStore);
        },
        transactionType: function(): string {
            return this.getValue("transaction.type");
        },
        getMessageError: function(): string|null {
            if(this.getErrorMessage(this.pathInStore)) {
                return this.getErrorMessage(this.pathInStore);
            }
            if(this.getErrorMessage("property")){
                return this.getErrorMessage("property");
            }
            return null;
        },
        options: function(): Array<Record<string, unknown>> {
            if (this.transactionType === "FOR_SALE") {
                return [
                    {
                        "label": this.$t("undefined"),
                        "value": "",
                    },
                    {
                        "label": this.$t("land"),
                        "value": "LAND",
                    },
                    {
                        "label": this.$t("garage"),
                        "value": "GARAGE"
                    },
                    {
                        "label": this.$t("office"),
                        "value": "OFFICE"
                    },
                    {
                        "label": this.$t("industry"),
                        "value": "INDUSTRY"
                    },
                    {
                        "label": this.$t("commercial"),
                        "value": "COMMERCIAL"
                    },
                    {
                        "label": this.$t("other"),
                        "value": "OTHER"
                    }
                ];
            } else {
                return [
                    {
                        "label": this.$t("undefined"),
                        "value": "",
                    },
                    {
                        "label": this.$t("garage"),
                        "value": "GARAGE"
                    },
                    {
                        "label": this.$t("office"),
                        "value": "OFFICE"
                    },
                    {
                        "label": this.$t("business"),
                        "value": "COMMERCIAL"
                    },
                    {
                        "label": this.$t("industry"),
                        "value": "INDUSTRY"
                    },
                    {
                        "label": this.$t("other"),
                        "value": "OTHER"
                    }
                ];
            }
        },

        currentSubtype: function(): string {
            switch (this.propertyType) {
            case "LAND": return "LAND";
            case "COMMERCIAL":
            case "BUSINESS": return "BUSINESS";
            case "OFFICE": return "OFFICES";
            case "INDUSTRY": return "INDUSTRIAL_PREMISES";
            case "GARAGE": return "OUTDOOR_PARKING_SPACE";
            case "OTHER": return "OTHER";
            default: return "";
            }
        }

    },
    watch: {
        transactionType: {
            handler: function(val) {
                return val;
            },
            deep: true
        },
    },
    methods: {
        ...mapActions({
            selectPropertyTypeOptimizedFunnel: "FormModule/setPropertyTypeOptimizedFunnel",
        }),

        updatePropertyType: function(propertyType: string) {
            if (this.propertyType !== propertyType) {

                const transactionSubtype: string = this.getValue("transaction.subtype") || "";

                this.selectPropertyTypeOptimizedFunnel(propertyType);

                const propertySubtype = this.currentSubtype;

                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStoreSubtype,
                    value: propertySubtype,
                });

                this.killAndSetValues(propertyType, propertySubtype, this.transactionType, transactionSubtype);
            }
        },

        killAndSetValues: async function(propertyType: string, propertySubtype: string, transactionType: string, transactionSubtype: string) {
            killNotRelevantCriteria(propertyType, propertySubtype, transactionType, transactionSubtype);
            addDefaultValuesToStore(propertyType, propertySubtype, transactionType, transactionSubtype);
            resetBasicInfo();
        }
    }
});
